// Centralized API base URL.
// Uses window.location.origin so that on any domain (preview or production),
// requests go through the same-origin ingress which routes /api/* to the backend.
// This prevents cookie domain mismatches and split-brain database issues.
export const API_BASE = `${window.location.origin}/api`;
